export default "__VITE_ASSET__aBA2Z4Hd__"